import React from 'react'
import {observer} from 'mobx-react';
import ProjectStore from '../../store/projectStore'
import renderField from '../edit-page/fields/FieldExtensions'
import Card from '../edit-page/Card';
import buildResourcePath from '@lib/buildResourcePath'
import HelpSystemInformation from '../common/HelpSystemInformation';

const ProjectGeneralInformation = observer(
    class ProjectGeneralInformation extends React.Component {

        state = {
            editable: []
        }

        onButtonEditClick = field => {
            var newEditable = _.xor(this.state.editable, [field.slug]);
            ProjectStore.generalInformationDuringEdit = newEditable.length > 0;

            this.setState({
                editable: newEditable,
                changeEditIcon: !this.state.changeEditIcon
            })
        }

        renderField = (field, possibleToEdit) => {
            return renderField(field, this.state.editable.includes(field.slug), possibleToEdit, this.onButtonEditClick, '', () => ProjectStore.setDirty(true));
        }


        createSubStatus = () => {
            if (this.props.canEdit) {
                return this.renderField(ProjectStore.formModel.generalInformation.subStatus, true)
            }

            return (
                <div className="configuration-editor-info-card-field">
                    <div
                        className="configuration-editor-info-card-field-label">{ProjectStore.formModel.generalInformation.subStatus.label}</div>
                    <div className="configuration-editor-info-card-field-value">
                        <span
                            className={`${ProjectStore.formModel.generalInformation.subStatusSlug.value}-label`}>{ProjectStore.formModel.generalInformation.subStatusName.value}</span>
                    </div>
                </div>
            )
        }

        renderParent = () => {
            return (
                <div className="configuration-editor-info-card-field">
                    <div
                        className="configuration-editor-info-card-field-label">{ProjectStore.formModel.generalInformation.parent.label}</div>
                    <div className="configuration-editor-info-card-field-value">
                        <a href={buildResourcePath(`/Project/Edit/${ProjectStore.formModel.generalInformation.parentId.value}`)}>{ProjectStore.formModel.generalInformation.parent.value}</a>
                    </div>
                </div>
            )
        }

        render() {
            return (
                <Card
                    helpInfo={this.props.helpInfo}
                    editableMode={this.props.canEdit}
                    label="General information">
                    <div className="row row-no-outer-gutter">
                        <div className="column-6 column-xs-12">
                            {this.renderField(ProjectStore.formModel.generalInformation.name, this.props.canEdit)}
                            {this.renderField(ProjectStore.formModel.generalInformation.number)}
                            {ProjectStore.formModel.generalInformation.so.visible && this.renderField(ProjectStore.formModel.generalInformation.so, this.props.canEdit)}
                            {ProjectStore.formModel.generalInformation.po.visible && this.renderField(ProjectStore.formModel.generalInformation.po, this.props.canEdit)}
                            {ProjectStore.formModel.generalInformation.parent.visible && this.renderParent()}
                        </div>
                        <div className="column-6 column-xs-12">
                            {this.createSubStatus()}
                            {ProjectStore.formModel.generalInformation.responsible.visible && this.renderField(ProjectStore.formModel.generalInformation.responsible, this.props.canEdit)}
                        </div>
                    </div>
                </Card>
            )
        }
    }
)

export default ProjectGeneralInformation;